var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container cardNovaConversa" }, [
    _c(
      "div",
      { staticClass: "card fullWidth cardPadding" },
      [
        _vm.idConversa
          ? _c("informacoes-conversa", {
              attrs: { idConversa: _vm.idConversa }
            })
          : _vm._e(),
        !_vm.idConversa
          ? _c(
              "el-row",
              { attrs: { type: "flex", gutter: 30 } },
              [
                _c(
                  "el-col",
                  {
                    staticClass: "container-input marginTop",
                    attrs: { md: 12, sm: 24 }
                  },
                  [
                    _c("validation-provider", {
                      attrs: {
                        rules: "required",
                        name: "Assunto",
                        mode: "lazy"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-label", {
                                  attrs: { label: "Assunto:", required: true }
                                }),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "fullWidth select",
                                    class: { erro: errors.length },
                                    attrs: {
                                      placeholder: "Selecione",
                                      "value-key": "codigo",
                                      name: "assunto"
                                    },
                                    model: {
                                      value: _vm.conversa.assunto,
                                      callback: function($$v) {
                                        _vm.$set(_vm.conversa, "assunto", $$v)
                                      },
                                      expression: "conversa.assunto"
                                    }
                                  },
                                  _vm._l(_vm.assuntos, function(item) {
                                    return _c("el-option", {
                                      key: item.codigo,
                                      attrs: {
                                        label: item.nome,
                                        value: item.codigo
                                      }
                                    })
                                  }),
                                  1
                                ),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1273272651
                      )
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "el-col",
          { staticClass: "container-input" },
          [
            _c("validation-provider", {
              attrs: { rules: "required", name: "Mensagem", mode: "eager" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var errors = ref.errors
                    return [
                      _c("app-label", {
                        attrs: { label: "Mensagem:", required: true }
                      }),
                      _c("app-text-editor", {
                        class: {
                          "input erro":
                            errors && errors.length > 0 ? true : false
                        },
                        attrs: { config: _vm.config },
                        model: {
                          value: _vm.conversa.mensagem,
                          callback: function($$v) {
                            _vm.$set(_vm.conversa, "mensagem", $$v)
                          },
                          expression: "conversa.mensagem"
                        }
                      }),
                      _c("span", { staticClass: "help erro" }, [
                        _vm._v(_vm._s(errors[0]))
                      ])
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _c(
          "el-col",
          { staticClass: "drop" },
          [
            _c("app-anexo", {
              attrs: { id: "upload-atualizacao-base", files: _vm.anexos },
              on: {
                uploadFile: _vm.uploadFile,
                removeFile: _vm.removeFile,
                downloadDocumentoCadastro: _vm.getDownload
              }
            })
          ],
          1
        ),
        _c(
          "el-col",
          [
            _c("app-buttons-cadastro", {
              staticClass: "btns",
              attrs: {
                isPrimeiroPasso: true,
                isUltimoPasso: true,
                showButtonFinalizar: false,
                showButtonEnviar:
                  (!!_vm.idConversa || !!_vm.conversa.assunto) &&
                  !!_vm.conversa.mensagem
              },
              on: { cancelar: _vm.cancelar, enviar: _vm.enviar }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30411d01", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30411d01","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/comunicacao/NovaConversa.vue
// module id = null
// module chunks = 